import React, { Component } from 'react';
import { sendEvent } from '../../helpers/analytics'

class ScrollPercentage extends Component {
  state = {
    scrollPercentage: {
      20: false,
      40: false,
      60: false,
      80: false,
      100: false
    }
  }
  wrapperRef = (node) => {this.wrapper = node}

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (e) => {

    let currentScroll = 100 * (document.documentElement.scrollTop - this.wrapper.offsetTop) / (this.wrapper.offsetHeight - window.innerHeight);

    let { scrollPercentage } = this.state
    const {category} = this.props

    if (currentScroll >= 20 && currentScroll < 40 && !scrollPercentage[20]) {
      scrollPercentage[20] = true
      this.setState({scrollPercentage})
      sendEvent(category, 'scroll', '20')
    } else if (currentScroll >= 40 && currentScroll < 60 && !scrollPercentage[40]) {
      scrollPercentage[40] = true
      this.setState({scrollPercentage})
      sendEvent(category, 'scroll', '40')
    } else if (currentScroll >= 60 && currentScroll < 80 && !scrollPercentage[60]) {
      scrollPercentage[60] = true
      this.setState({scrollPercentage})
      sendEvent(category, 'scroll', '60')
    } else if (currentScroll >= 80 && currentScroll < 100 && !scrollPercentage[80]) {
      scrollPercentage[80] = true
      this.setState({scrollPercentage})
      sendEvent(category, 'scroll', '80')
    } else if (currentScroll >= 100 && !scrollPercentage[100]) {
      scrollPercentage[100] = true
      this.setState({scrollPercentage})
      sendEvent(category, 'scroll', '100')
    }
  }

  render () {
    return (
      <div ref={this.wrapperRef}>
        {this.props.children}
      </div>
    )
  }
}

export default ScrollPercentage


// WEBPACK FOOTER //
// ./src/components/scroll-percentage/scroll-percentage.js